import React, {ChangeEvent, useEffect, useState} from 'react';
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import useSystemLanguage from "../../../modules/language/hooks/useSystemLanguage";
import {SimpleSelect} from "../../../components/Adescom/SimpleSelect";
import PlatformResellerInterface from "../../../interfaces/platform/PlatformResellerInterface";
import {REQUEST_STATE} from "../../../helpers/RequestHelper";
import {PlatformResellerSendType} from "../PlatformResellerModify";
import CustomMultiSelect from "../../../components/Form/CustomMultiSelect";
import useResellerAvailableSystemLanguages from "../../../modules/language/hooks/useResellerAvailableSystemLanguages";

interface PlatformResellerLanguagePropsInterface {
    platformResellerId: string | null | undefined;
    platformReseller: PlatformResellerInterface | PlatformResellerSendType;
    changeDefaultLanguageCallback: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    changeAvailableLanguagesCallback: (langs: Array<number>) => void;
}

const PlatformResellerLanguage: React.FC<PlatformResellerLanguagePropsInterface> = (props) => {
    const {
        platformReseller,
        changeDefaultLanguageCallback,
        changeAvailableLanguagesCallback,
        platformResellerId
    } = props;

    const resId = platformResellerId ? platformResellerId.split('/')[platformResellerId.split('/').length - 1] : null;

    const {state: systemLanguageState, systemLanguageCollection} = useSystemLanguage();
    const {
        state: resellerAvailableLanguagesState,
        resellerAvailableLanguagesCollection
    } = useResellerAvailableSystemLanguages([{
        name: 'platformResellerId',
        value: resId ?? -1
    }]);

    const [resellerLangsChangedOnLoad, setResellerLangsChangedOnLoad] = useState<boolean>(false);

    useEffect((): void => {
        if (platformReseller && resellerAvailableLanguagesCollection && !resellerLangsChangedOnLoad) {
            const langs = resellerAvailableLanguagesCollection['hydra:member'].map(el => {
                return el.systemLanguageId;
            })
            changeAvailableLanguagesCallback(langs);
            setResellerLangsChangedOnLoad(true);
        }
    }, [platformReseller, resellerAvailableLanguagesCollection, changeAvailableLanguagesCallback, resellerLangsChangedOnLoad]);

    if (!resellerAvailableLanguagesCollection || !systemLanguageCollection) {
        return null;
    }

    if (systemLanguageState !== REQUEST_STATE.IDLE && resellerAvailableLanguagesState !== REQUEST_STATE.IDLE) {
        return null;
    }

    return (
        <GridContainer spacing={1}>
            <GridItem xs={6}>
                <SimpleSelect
                    label={'platform_reseller:pr.default_reseller_language'}
                    required={true}
                    elements={systemLanguageCollection['hydra:member'].map(el => {
                        return {name: `general:language.${el.language}`, value: el.id ?? -1}
                    })}
                    dispatchName={'layout'}
                    fieldName={'layout'}
                    selectedValue={platformReseller.defaultSystemLanguageId}
                    callback={changeDefaultLanguageCallback}
                />
            </GridItem>
            <GridItem xs={6}>
                <CustomMultiSelect
                    callback={(event): void => {
                        const val = event.target.value;
                        console.log(val);
                        if (Array.isArray(val)) {
                            changeAvailableLanguagesCallback(val);
                        }
                    }}
                    value={platformReseller.resellerAvailableLanguages ? JSON.parse(platformReseller.resellerAvailableLanguages) : []}
                    name={'resellerAvailableLanguages'}
                    isElementsFromApi={false}
                    elements={systemLanguageCollection['hydra:member'].map(el => {
                        return {name: `general:language.${el.language}`, value: el.id ?? -1}
                    })}
                    elementItemValue={'value'}
                    elementItemName={'name'}
                    label={'platform_reseller:pr.available_reseller_language'}
                    showSelectAllButton
                />
            </GridItem>
        </GridContainer>
    );
};

export default PlatformResellerLanguage;
